<!-- <mat-card>
  <form *ngIf='!isLoading' (submit)='onSignUp(signUpForm)' #signUpForm="ngForm">
    <mat-form-field>
      <input matInput type="email" name="email" ngModel required email placeholder="e-mail" #emailInput="ngModel">
      <mat-error *ngIf="emailInput.invalid">"please enter valid email"</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input type="password" name="password" ngModel matInput placeholder="password" #passwordInput="ngModel" required>
      <mat-error *ngIf="passwordInput.invalid">"please enter valid password"</mat-error>
    </mat-form-field>
    <button mat-raised-button color="accent" type="submit">Sign UP</button>
  </form>
</mat-card> -->


<div class="form-container sign-up-container">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <form *ngIf='!isLoading' (submit)='onSignUp(signUpForm)' #signUpForm="ngForm">
    <nb-card>
      <nb-card-body fxLayout="column">
        <span>
          <img src="../../../assets/logo2.png" alt="" srcset="" style="width: 112px;height: 112px;">
        </span>
        <h3>Create eGlu Console Account</h3>
        <span>Enter your details below.</span>
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <!-- <input type="text" placeholder="Name" /> -->
          <input type="text" name="name" matInput ngModel placeholder="Name" #nameInput="ngModel" required>
          <mat-error *ngIf="nameInput.invalid">"please enter name"</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" name="email" ngModel required email placeholder="e-mail" #emailInput="ngModel">
          <mat-error *ngIf="emailInput.invalid">"please enter valid email"</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input type="password" name="password" ngModel matInput placeholder="password" #passwordInput="ngModel" required>
          <mat-error *ngIf="passwordInput.invalid">"please enter valid password"</mat-error>
        </mat-form-field>
        <button type="submit">Sign Up</button>
        <a href="/login">go back to Login page</a>
      </nb-card-body>
    </nb-card>
  </form>
</div>
